/*
 *
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import IntegrationChannel from './integration-channel';
import IntegrationChannelDetail from './integration-channel-detail';
import IntegrationChannelUpdate from './integration-channel-update';
import IntegrationChannelDeleteDialog from './integration-channel-delete-dialog';

const IntegrationChannelRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<IntegrationChannel />} />
    <Route path="new" element={<IntegrationChannelUpdate />} />
    <Route path=":id">
      <Route index element={<IntegrationChannelDetail />} />
      <Route path="edit" element={<IntegrationChannelUpdate />} />
      <Route path="delete" element={<IntegrationChannelDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default IntegrationChannelRoutes;
